







import Vue from 'vue';
import { ErrorDisplay } from '@/util/util';

export default Vue.extend({
  props: {
    error: Object as () => ErrorDisplay|null,
  },
});

